import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import AdminPanel from './components/AdminPanel';
import AdminAuth from './pages/AdminAuth';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin-auth" element={<AdminAuth />} />
      </Routes>
      <Link to="/admin-auth" className="admin-access-button">Admin</Link>
    </Router>
  );
}

export default App;